const BigNumber = require('bignumber.js');

export function BoldIdGeneratorService() {
  function generateId() {
    const MAX_LONG64 = '9223372036854775807';

    // Calling .times(Math.random()) with Math.random will cause an error - you need toString as well.
    // Documentation on the issue is here: https://github.com/MikeMcl/bignumber.js/issues/11
    const randomBigNumber = new BigNumber(MAX_LONG64).times(Math.random().toString()).round().toString();
    return randomBigNumber;
  }

  return {
    generateId
  };
}
